import React, { useRef, useState } from "react";
import "./industries.scss";


const Industries = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const togglePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };
    return (
        <>
            <section className='industries_main' id='ourwork'>
                <div className='custom-container1'>
                    <div className='innner_Side'>
                        <h3>Automate Your Processes <br /> the No-Code Way</h3>
                        <div className='bootom_side_section'>
                            <div className='fouuur_cards'>
                                <div className='card_inside'>
                                    <h4>01.</h4>
                                    <h5>Approvals</h5>
                                </div>
                                <div className='card_inside'>
                                    <h4>02.</h4>
                                    <h5>onboarding</h5>
                                </div>
                                <div className='card_inside'>
                                    <h4>03.</h4>
                                    <h5>Document Generation</h5>
                                </div>
                                <div className='card_inside'>
                                    <h4>04.</h4>
                                    <h5>reports</h5>
                                </div>
                            </div>
                            <div>
                                <div
                                    className="video-wrapper"
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        margin: "0 auto",

                                    }}
                                >
                                    <video
                                        ref={videoRef}
                                        src="\assets\automation-video.mp4"
                                        muted
                                        loop
                                        playsInline
                                        style={{ width: "100%", borderRadius: "12px" }}
                                    />

                                    <button
                                        className="play-pause-button"
                                        onClick={togglePlayPause}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            backgroundColor: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            padding: 0,
                                        }}
                                    >
                                        {isPlaying ? (
                                            <span style={{ fontSize: "40px", color: "white" }}>❚❚</span>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="100"
                                                height="100"
                                                viewBox="0 0 100 100"
                                                fill="none"
                                            >
                                                <rect
                                                    x="100"
                                                    width="100"
                                                    height="100"
                                                    rx="50"
                                                    transform="rotate(90 100 0)"
                                                    fill="white"
                                                    fillOpacity="0.2"
                                                />
                                                <path
                                                    d="M73.1616 44.9088C76.9461 46.8004 76.9461 52.1996 73.1616 54.0913L38.431 71.4514C35.017 73.158 31 70.6762 31 66.8602L31 32.1398C31 28.3239 35.017 25.842 38.431 27.5485L73.1616 44.9088Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                                <div className="pdf_div">
                                    <h6>Save 100+ hours/month. Explore our 60+ ready-to-use workflows</h6>
                                    <a href="\power-automate-portfolio.pdf" download>
                                        <button>Access Automation Portfolio  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M6 7.33331V11.3333L7.33333 9.99998" stroke="#000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M6.00033 11.3333L4.66699 10" stroke="#000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M14.6663 6.66665V9.99998C14.6663 13.3333 13.333 14.6666 9.99967 14.6666H5.99967C2.66634 14.6666 1.33301 13.3333 1.33301 9.99998V5.99998C1.33301 2.66665 2.66634 1.33331 5.99967 1.33331H9.33301" stroke="#000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M14.6663 6.66665H11.9997C9.99967 6.66665 9.33301 5.99998 9.33301 3.99998V1.33331L14.6663 6.66665Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg></button>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>



            </section>
        </>
    )
}

export default Industries
